import { render, staticRenderFns } from "./BackgroundLifecycle.vue?vue&type=template&id=3bccfeb8"
import script from "./BackgroundLifecycle.vue?vue&type=script&lang=js"
export * from "./BackgroundLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports